import { render, staticRenderFns } from "./ReasonsPreview.vue?vue&type=template&id=26fdbe24"
import script from "./ReasonsPreview.vue?vue&type=script&lang=js"
export * from "./ReasonsPreview.vue?vue&type=script&lang=js"
import style0 from "./ReasonsPreview.vue?vue&type=style&index=0&id=26fdbe24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports